import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslate } from 'react-translate.ts';
import { LoadingOverlay } from '@tcc-online/common-components';
import { useNavigate } from 'react-router-dom';

import { ForgottenPasswordForm } from './parts/ForgottenPasswordForm';
import AuthActions from '../../../auth/actions/AuthActions';
import AuthSelectors from '../../../auth/selectors/AuthSelectors';
import { SIGN_IN_PATH } from '../../../constants/route.constants';
import { TRANSLATIONS_ROOT_KEY } from '../../../constants/translation.constants';
import { AppDispatch } from '../../../reducers/store';
import { NotificationActions } from '../../../common/actions/NotificationActions';
import AuthLayout from '../AuthLayout/AuthLayout';
import AuthCard from '../../../components/auth/AuthCard/AuthCard';

export default function ForgottenPasswordPage() {
    const translate = useTranslate(
        TRANSLATIONS_ROOT_KEY + '.forgotten-password',
    );
    const { loading, error } = useSelector(AuthSelectors.getPasswordRequest);
    const dispatch = useDispatch<AppDispatch>();
    const navigate = useNavigate();

    useEffect(() => {
        return () => {
            // noinspection JSVoidFunctionReturnValueUsed
            dispatch(AuthActions.reinit());
        };
    }, [dispatch]);

    return (
        <>
            <LoadingOverlay isLoading={loading} />
            <AuthLayout>
                <AuthCard
                    isLoading={loading}
                    header={
                        <div className="text-primary uppercase">
                            {translate('title')}
                        </div>
                    }
                >
                    <ForgottenPasswordForm onSubmit={submit} error={!!error} />
                </AuthCard>
            </AuthLayout>
        </>
    );

    async function submit(email: string) {
        try {
            await dispatch(
                AuthActions.requestResetPassword({ email }),
            ).unwrap();
            dispatch(NotificationActions.success(translate('success')));
        } finally {
            navigate(SIGN_IN_PATH, { relative: 'path' });
        }
    }
}
